import { htmlContent, setTagStyle, setTagClass } from '../util/util';
import { ModalOption } from '../../interface/IModal';

export const makeModalContent = (options: ModalOption): string => {
    const $modalTemplate = `<div class="ncuim-container${setTagClass(
        options.customClass!
    )}">
            <div class="ncuim-wrapper"${setTagStyle(
                options.width ? `width: ${options.width}` : ''
            )}>
                ${renderCloseBtn(options)}
                <div class="ncuim-content${
                    options.showConfirmButton || options.showCancelButton
                        ? ' has-button'
                        : ''
                }">
                    ${renderTitle(options)}
                    ${renderHtml(options)}
                </div>
                ${renderButtons(options)}
            </div>
        </div>`;

    return $modalTemplate;
};

const renderCloseBtn = (options: ModalOption): string => {
    return options.showCloseButton
        ? `<button class="ncuim-close"></button>`
        : '';
};
const renderTitle = (options: ModalOption): string => {
    return options.title
        ? `<div class="ncuim-title">${htmlContent(options.title)}</div>`
        : '';
};
const renderHtml = (options: ModalOption): string => {
    return options.html
        ? `<div class="ncuim-html-container">${htmlContent(options.html)}</div>`
        : '';
};
const renderButtons = (options: ModalOption): string => {
    return options.showConfirmButton || options.showCancelButton
        ? `<div class="ncuim-buttons">
            ${
                options.showCancelButton
                    ? `<button type="button" class="ncuim-button__cancel${
                          !options.showConfirmButton
                              ? ' ncuim-button__union'
                              : ''
                      }"${setTagStyle(
                          options.cancelButtonColor
                              ? `background-color: ${options.confirmButtonColor}`
                              : ''
                      )}>
                        ${options.cancelButtonText}
                    </button>`
                    : ''
            }
            ${
                options.showConfirmButton
                    ? `<button type="button" class="ncuim-button__confirm${
                          !options.showCancelButton
                              ? ' ncuim-button__union'
                              : ''
                      }"${setTagStyle(
                          options.confirmButtonColor
                              ? `background-color: ${options.confirmButtonColor}`
                              : ''
                      )}>
                        ${options.confirmButtonText}
                    </button>`
                    : ''
            }
        </div>`
        : '';
};
